
import * as fromRoot from '../../reducers'
import * as fromOrderHistory from './order-history.reducer'
import * as fromOrderHistoryLines from './order-history-lines.reducer'
import * as fromReOrderableItems from './re-orderable-items.reducer';
import * as fromRouter from '../../reducers'

import { createFeatureSelector, createSelector } from '@ngrx/store'

export interface OrderHistoryState {
  orderhistory: fromOrderHistory.State
  orderhistorylines: fromOrderHistoryLines.State
  reorderableitems: fromReOrderableItems.State
}

export interface State extends fromRoot.State {
  orderhistory: OrderHistoryState
}

export const reducers = {
  orderhistory: fromOrderHistory.reducer,
  orderhistorylines: fromOrderHistoryLines.reducer,
  reorderableitems: fromReOrderableItems.reducer,
}

// Feature selector
export const getOrderHistoryState = createFeatureSelector<OrderHistoryState>('orderhistory')

// State selectors
export const getOrderHistoryReducerState = createSelector(
  getOrderHistoryState,
  (state: OrderHistoryState) => state.orderhistory
)

export const getOrderHistoryLinesReducerState = createSelector(
  getOrderHistoryState,
  (state: OrderHistoryState) => state.orderhistorylines
)

export const getReOrderableItemsReducerState = createSelector(
  getOrderHistoryState,
  (state: OrderHistoryState) => state.reorderableitems
)

// Orderhistory selectors
export const getOrderHistory = createSelector(
  getOrderHistoryReducerState,
  fromOrderHistory.getOrderHistory
)

export const getOrderHistoryLoading = createSelector(
  getOrderHistoryReducerState,
  fromOrderHistory.getLoading
)

export const getOrderHistoryExpanding = createSelector(
  getOrderHistoryReducerState,
  fromOrderHistory.getExpanding
)

export const getOrderHistoryNextPage = createSelector(
  getOrderHistoryReducerState,
  fromOrderHistory.getNextPage
)

export const getOrderHistoryItem = createSelector(
  getOrderHistoryReducerState,
  fromOrderHistory.getOrderHistoryItem
)

// Orderhistorylines selectors
export const getOrderHistoryLines = createSelector(
  getOrderHistoryLinesReducerState,
  fromOrderHistoryLines.getOrderHistoryLines
)

export const getOrderHistoryLinesLoading = createSelector(
  getOrderHistoryLinesReducerState,
  fromOrderHistoryLines.getLoading
)

export const getOrderHistoryLinesExpanding = createSelector(
  getOrderHistoryLinesReducerState,
  fromOrderHistoryLines.getExpanding
)

export const getOrderHistoryLinesNextPage = createSelector(
  getOrderHistoryLinesReducerState,
  fromOrderHistoryLines.getNextPage
)

export const getSelectedOrdernumber = createSelector(
  fromRouter.getRouterInfo,
  (routerState) => {
    if (routerState && routerState.params && routerState.params['ordernumber'] && !isNaN(routerState.params['ordernumber'])) {
      return +routerState.params['ordernumber']
    }
  }
)

// ReOrderable items selectors
export const getReOrderableItemCodes = createSelector(
  getReOrderableItemsReducerState,
  fromReOrderableItems.getReOrderableItemCodes
)
